export class ReDeclarer{

    private invalidPropertiesAndMethods:Set<string>;
    public redeclare(source:any,destination:any){
        this.invalidPropertiesAndMethods = new Set<string>();
        let items = []
        items.push(...this.getMethods(destination));
        items.push(...this.getAllEntries(destination));
        items.forEach(x=>this.invalidPropertiesAndMethods.add(x));
        let methods = this.getMethods(source);
        let properties = this.getAllEntries(source);

        properties.forEach(element => {
            if(destination[element]==undefined){
                Object.defineProperty(destination,element,{
                    set:(function(x){destination['decoratorComponent'][element]=x}).bind(destination),
                    get:(function(){return destination['decoratorComponent'][element];}),
                    configurable:true
                });
            }
        });
        methods.forEach(element=>{
            destination[element]=(function(...args){
                return this['decoratorComponent'][element](...args);
            }).bind(destination);
        });
    }

    private getMethods(o:object){
        let properties = new Set<string>()
        let currentObj = o;
        do {
            Object.getOwnPropertyNames(currentObj).map(item => properties.add(item))
        } while ((currentObj = Object.getPrototypeOf(currentObj)));
        return [...properties.keys()].filter(item => typeof o[item] === 'function' && this.invalidPropertiesAndMethods.has(item)==false)
    }

    
    private getAllEntries(obj:any):Set<string>{
        let result : any[] = [];
        let o = obj;
        do{
            let names = Object.getOwnPropertyNames(o);
            let desc = Object.getOwnPropertyDescriptors(o);
            let map = names.map(x=>[x,desc[x]]);
            result.push(...map.filter(x=>x[1]['value']===undefined && (<any>x[0]).startsWith('__')==false && this.invalidPropertiesAndMethods.has(<any>x[0])==false))
        }while((o=Object.getPrototypeOf(o)));
        return new Set(result.map(x=>x[0]));
    }


}